import React, {useContext, useEffect} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TabContext from "@/contexts/TabContext";

export const PageTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    const getPathnameWithoutQuery = (url) => {
        return url.split("?")[0];
    };

    return (
        <div className="page-tab">
            <ul className="tab-list">
                {tabs.map((tab, index) => (
                    <li
                        key={index}
                        className={
                            getPathnameWithoutQuery(location.pathname) === getPathnameWithoutQuery(tab.url)
                                ? "opened-page active"
                                : "opened-page"
                        }
                    >
                        <span className="page-title" onClick={() => navigate(tab.url)}>
                            {tab.title}
                        </span>
                        <button
                            type="button"
                            className="btn-remove_page"
                            onClick={() => dispatch({ type: "REMOVE_TAB", payload: tab.url })}
                        ></button>
                    </li>
                ))}
            </ul>
        </div>
    );
};


export const CustomPageTabs = ({ title }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: title },
                });
            }
        };

        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    const getPathnameWithoutQuery = (url) => {
        return url.split("?")[0];
    };

    return (
        <div className="page-tab">
            <ul className="tab-list">
                {tabs.map((tab, index) => (
                    <li
                        key={index}
                        className={
                            getPathnameWithoutQuery(location.pathname) === getPathnameWithoutQuery(tab.url)
                                ? "opened-page active"
                                : "opened-page"
                        }
                    >
                        <span className="page-title" onClick={() => navigate(tab.url)}>
                            {tab.title}
                        </span>
                        <button
                            type="button"
                            className="btn-remove_page"
                            onClick={() => dispatch({ type: "REMOVE_TAB", payload: tab.url })}
                        ></button>
                    </li>
                ))}
            </ul>
        </div>
    );
};